import { render, staticRenderFns } from "./dynamic-so.vue?vue&type=template&id=36fd2d59&scoped=true&"
import script from "./dynamic-so.vue?vue&type=script&lang=js&"
export * from "./dynamic-so.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-so.vue?vue&type=style&index=0&id=36fd2d59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fd2d59",
  null
  
)

export default component.exports